import {frontageApiService} from "@/plugins/frontage-api";


const get = () => {
  return frontageApiService.get('get-quick-actions')
}

export default {
  get,
}